import { combineReducers } from "redux";

import { content } from "store/ducks";

import {
  authReducer,
  onboardingReducer,
  categorieReducer,
  userReducer,
  contentReducer,
  sliderReducer,
  adReducer,
  mediaReducer,
  paymentReducer,
  searchReducer,
  followReducer,
  mailReducer,
  appReducer,
  serieReducer,
  gaReducer,
  carruselsReducer,
  suggestionReducer
} from "store/reducers"

export const rootReducer = combineReducers({
  authReducer,
  onboardingReducer,
  categorieReducer,
  userReducer,
  contentReducer,
  sliderReducer,
  adReducer,
  mediaReducer,
  paymentReducer,
  searchReducer,
  followReducer,
  mailReducer,
  appReducer,
  serieReducer,
  gaReducer,
  carruselsReducer,
  suggestionReducer,

  /** New and clean reducers from @store/ducks */
  content,
})